
import { ViewItem } from '../../Components/Views/ViewItem';
import './not-found.css';

class NotFoundView extends ViewItem {
    render() {
        return (
            <div className="page nf-page">
                <div className="nf-card">
                    <a href="/" className="nf-logo">Wyens</a>
                    <div className="nf-code">404</div>
                    <h1 className="nf-title">Page not found</h1>
                    <p className="nf-desc">The page you're looking for doesn't exist or has been moved.</p>
                    <div className="nf-actions">
                        <a href="/" className="nf-btn-primary">Back to home →</a>
                        <a href="/help" className="nf-btn-ghost">Help & FAQ</a>
                    </div>
                </div>
            </div>
        )
    }
}

export { NotFoundView }